import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { AnonymousRouterIndex } from './AnonymousRouterIndex'

import { OpenAPI } from './generated/index'

import { Toaster } from 'react-hot-toast'
import { Overlay, OverlayProvider } from './genericComponents/Overlay'

/// <reference types="../react-app-env.d.ts" />

const queryClient = new QueryClient()

//set OpenAPI base url empty so that requests are send to relative url and not the local host where api docs where generated
OpenAPI.BASE = ''

Array.from(document.getElementsByClassName('react')).forEach((el) => {
  if (el) {
    const root = ReactDOM.createRoot(el)
    root.render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <OverlayProvider>
            <Toaster position="bottom-right" toastOptions={{ duration: 5000 }} />
            <Overlay />
            <AnonymousRouterIndex />
          </OverlayProvider>
        </QueryClientProvider>
      </React.StrictMode>
    )
  }
})
